import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Login from './component/login/login';
import Home from './component/home/home';
import Admin from './component/admin/admin';
import UserHome from './component/userHome/userHome';
import ViewAudit from './pages/viewAudit/viewAudit';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<UserHome />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </Router>
  );
}

export default App;
